// src/context/AuthContext.js

import React, { useContext, useState, useEffect, createContext } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      // Start with the basic user state set to null, then check for details
      let finalUserData = null;
      
      if (user) {
        try {
          // 1. Fetch user's role from Firestore
          const userDocRef = doc(db, "contributors", user.uid);
          const userDocSnap = await getDoc(userDocRef);

          if (userDocSnap.exists()) {
            finalUserData = {
              uid: user.uid,
              email: user.email,
              ...userDocSnap.data(), // This will add the 'role' field
            };
          } else {
            console.error("User document not found in Firestore:", user.uid);
            finalUserData = user; // Set basic user data if role is missing
          }
        } catch (error) {
          // Handle any errors during Firestore fetch (e.g., network issues)
          console.error("Error fetching user role:", error);
          finalUserData = user; // Still consider them logged in with basic data
        }
      } 
      
      // 2. Update state and mark loading as false ONLY after all checks are complete
      setCurrentUser(finalUserData);
      setLoading(false); // CRITICAL FIX: Always set loading to false here
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    loading, // Export the loading state
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}